import styled from '@emotion/styled'

export const Item = styled.div`
  &.item-info {
  padding-bottom: 10px;
  }
`

export const FirstLine = styled.div`
  display: grid;
  grid-template-columns: 20px 60px auto;
  padding: 2px 0;
`

export const SecondLine = styled.div`
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  padding: 2px 0;

  .value {
    text-align: right;
  }
`
